exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialog-map-padding {\n  display: table-cell;\n  height: 100%;\n  position: relative; }\n\n@media screen and (max-width: 767px) {\n  .dialog-map-padding {\n    display: table-cell;\n    height: 100%;\n    position: relative; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/modal/dialog-map/dialog-map.component.scss
// module id = 923
// module chunks = 22